import Button from "../core/Button";
import ResizableScene from "../core/ResizableScene";
import { DecorationCategory } from "./DecorationMenu";

export default class CategoryButton extends Phaser.GameObjects.Container {
	protected button: Button;
	//protected categoryIcon: Phaser.GameObjects.Image;

	protected decoCategory: DecorationCategory;
	public get category(): DecorationCategory {
		return this.decoCategory;
	}
	xPosition: number;
	outPosition: number;
	activeCategory: boolean = false;
	constructor(scene: ResizableScene, category: DecorationCategory, callback?: (category: DecorationCategory) => any, context?: any) {
		super(scene);
		this.xPosition = this.x + 35;
		this.outPosition = this.xPosition - 18;
		this.decoCategory = category;
		this.button = scene.add.button(0, 0, `${category}TabOut`);
		this.button.clickSoundKey = "dressupTabPress";
		//this.categoryIcon = scene.add.image(0, 0, `${category}CatIcon`);
		//const widthRatio = (this.button.width - 20) / this.categoryIcon.width;
		//const heightRatio = (this.button.height - 20) / this.categoryIcon.height;
		//this.categoryIcon.setScale(Math.min(widthRatio, heightRatio));
		this.add([this.button]);
		this.setSize(this.button.width, this.button.height);

		if (callback) {
			if (context) callback = callback.bind(context);
			this.button.setCallback(() => callback(this.decoCategory));
		}
	}

	enableButton(enable: boolean): void {
		//this.categoryIcon.setAlpha(!enable ? 1 : 0.5);
		const category = this.category;
		this.button.setTexture(!enable ? `${category}TabOut` :`${category}TabIn`);
		this.activeCategory = enable;
		if (enable){
			this.scene.tweens.add({
				targets: this,
				x: this.xPosition,
				duration: 250,
				ease: Phaser.Math.Easing.Linear
			});
		}else{
			this.scene.tweens.add({
				targets: this,
				x: this.outPosition,
				duration: 250,
				ease: Phaser.Math.Easing.Linear
			});
		}
		this.button.buttonEnabled = enable;
	}
}